import React from 'react';
import styled from 'styled-components';

interface DataCardProps {
  title: string;
  value: string | number;
  icon?: React.ReactNode;
  className?: string;
  renderActions?: () => React.ReactNode
  content?: React.ReactNode
}

const StyledDataCard = styled.div`
  backdrop-filter: blur(4px);
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow:  0 4px 6px -1px rgba(0, 0, 0, 0.1),  
  0 2px 4px -1px rgba(0, 0, 0, 0.06); 
  border-radius: var(--radius);
  padding: 1rem;
  transition: all 0.3s ease;
  animation: fadeIn 0.6s ease-out;

  &:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const CardContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

const CardInfoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

const IconContainer = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: hsla(var(--primary), 0.1);
  color: hsl(var(--primary));
`;

const TextContainer = styled.div``;

export const CardLabel = styled.h3`
  font-size: 13px;
  font-weight: 500;
  color: hsl(var(--muted-foreground));
  margin-bottom: 0.25rem;
`;

export const CardValue = styled.p`
  font-size: 14px;
  font-weight: 600;
`;

const DataCard: React.FC<DataCardProps> = ({
  title,
  value,
  icon,
  className,
  content,
  renderActions
}) => {
  return (
    <StyledDataCard className={className}>
      <CardContent>
        <CardInfoSection>
          {icon && <IconContainer>{icon}</IconContainer>}
          <TextContainer>
            <CardLabel>{title}</CardLabel>
            <CardValue>{value}</CardValue>
            {content}
          </TextContainer>
        </CardInfoSection>
        {renderActions && renderActions()}
      </CardContent>
    </StyledDataCard>
  );
};

export default DataCard;